import styled from 'styled-components';
import { motion } from 'framer-motion';

export const DrawerWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  bottom: 0;
  pointer-events: none;
  /* z-index: 1; */
  z-index: ${({ zIndex }) => zIndex};
`;

export const DrawerOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: ${({ overlayColor, status }) =>
    status === 'closed' ? 'transparent' : overlayColor};
  z-index: 0;
  pointer-events: ${({ status, overlayColor }) =>
    status === 'closed' || overlayColor == 'transparent' ? 'none' : 'all'};
`;

export const DrawerContent = styled(motion.div)`
  position: relative;
  z-index: 1;
  pointer-events: all;
  background-color: #fff;
  width: 100%;
  height: ${({ height }) => `${height + 100}px`};
  padding-bottom: 100px;

  box-sizing: border-box;
  border-radius: 8px 8px 0px 0px;
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.14),
    0px 6px 30px rgba(0, 0, 0, 0.12), 0px 8px 10px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DrawerControl = styled(motion.button)`
  border: none;
  background: transparent;
  border-radius: 0;
  outline: none;
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
`;

export const DrawerTopHover = styled(motion.div)`
  border: none;
  background: transparent;
  border-radius: 0;
  outline: none;
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
`;

export const RectangleIcon = styled.div`
  width: 50px;
  height: 5px;
  background: #4c4c4c;
  border-radius: 8px;
  margin: 20px 0px;
`;

export const StyledTitleContainer = styled.div`
  height: 52px;
  display: flex;
  border-bottom: 1px solid rgb(234, 234, 234);
  width: 100%;
`;

export const StyledTitle = styled.div`
  width: 100%;
  margin: 0px;
  padding: 0.775rem 1.55rem;
  font-weight: 600;
  font-size: 24px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #4c4c4c;
`;

export const StyledContentContainer = styled.div`
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  overflow: auto;
  white-space: nowrap;

  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;

  background:
    linear-gradient(
        white 30%,
        rgba(255, 255, 255, 0)
      )
      center top,
    linear-gradient(rgba(255, 255, 255, 0), white 70%)
      center bottom,
      radial-gradient(
        farthest-side at 50% 0,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      )
      center top,
      radial-gradient(
        farthest-side at 50% 100%,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      )
      center bottom;

  background-repeat: no-repeat;
  background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
  background-attachment: local, local, scroll, scroll;
`;

export const StyledSectionContainer = styled.div`
  padding: 0 1rem 3rem 1rem;
  overflow-y: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;

  background: linear-gradient(white 30%, rgba(255, 255, 255, 0)) center top,
    linear-gradient(rgba(255, 255, 255, 0), white 70%) center bottom,
    radial-gradient(
        farthest-side at 50% 0,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      )
      center top,
    radial-gradient(
        farthest-side at 50% 100%,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      )
      center bottom;

  background-repeat: no-repeat;
  background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
  background-attachment: local, local, scroll, scroll;
`;

export const StyledContent = styled.div`
  margin: 5px 10%;
  display: flex;
  flex-direction: column;
`;

export const StyledContentRow = styled.div`
  padding: 10px;
`;
export const StyledContentRowTitle = styled.div`
  font-weight: 600;
  padding-bottom: 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #4c4c4c;
`;

export const StyledContentRowContent = styled.div``;

export const StyledButtonGroup = styled.div`
    display: flex;
    width: 100%;
    align-content: center;
    justify-content: center;
    padding: 1rem;
}`;

export const StyledButton = styled.button`
  margin: 0 5px;
  align-items: center;
  padding: 12px 16px;
  height: 48px;
  background: #ffffff;
  box-shadow: 0;
  border-radius: 4px;
  border: 1px solid #096bc8;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #096bc8;
  &:hover {
    background: #eaeaea;
  }
`;

export const StyledDeleteButton = styled.button`
  width: 250px;
  margin: 0 5px;
  align-items: center;
  padding: 12px 16px;
  height: 48px;
  background: #ffffff;
  box-shadow: 0;
  border-radius: 4px;
  border: 1px solid #096bc8;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #096bc8;
  &:hover {
    background: #eaeaea;
  }
`;

export const StyledIconButton = styled.button`
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  cursor: pointer;
  user-select: none;
  vertical-align: middle;
  appearance: none;
  text-decoration: none;
  text-align: center;
  flex: 0 0 auto;
  font-size: 1.5rem;
  padding: 8px;
  margin-right: 5px;

  align-items: center;
  background: #ffffff;
  box-shadow: 0;
  border-radius: 4px;
  border: 1px solid #096bc8;
  font-style: normal;
  font-weight: 400;

  line-height: 24px;
  color: #096bc8;
  &:hover {
    background: #eaeaea;
  }
`;

export const StyledCloseButton = styled.button`
  padding: 1.03333rem;
  position: absolute;
  right: 0;
  width: auto;
  background: transparent;
  white-space: nowrap;
  background: transparent;
  border: none;
  color: rgb(128, 128, 128);
  text-align: initial;
  height: 52px;
  &:hover {
    background: #eaeaea;
  }
`;

export const StyledTextBoxContainer = styled.div`
  box-sizing: border-box;
  position: relative;
  cursor: text;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 0 10px 0px;
  position: relative;
  border-radius: 4px;
  width: 100%;
`;

export const StyledTextBox = styled.textarea`
  font: inherit;
  letter-spacing: inherit;

  padding: 10px;
  box-sizing: content-box;
  background: none;
  height: auto;
  margin: 0;
  -webkit-tap-highlight-color: transparent;
  display: block;
  min-width: 0;
  width: 100%;
  resize: none;

  border: 0;
  border-radius: inherit;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  min-width: 0%;
  border-color: rgba(0, 0, 0, 0.23);

  white-space: normal;
  overflow: auto;

  &:focus {
    outline-color: #096bc8;
  }
`;

export const StyledNoteBox = styled.div`
  width: 100%;
  position: relative;
  display: inline-flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  min-width: 0%;
  margin: 0px 10px 10px 0px;
  white-space: normal;
`;
